var _circle, _path, _defs, _animateTransform;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#ACACAC",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.0711C6.158 20.2339 7.58372 21.092 9.15087 21.5694C10.718 22.0468 12.3782 22.1287 13.9844 21.8079C15.5906 21.487 17.0932 20.7734 18.3592 19.7301C19.6251 18.6868 20.6153 17.3462 21.242 15.8268C21.8687 14.3075 22.1126 12.6564 21.952 11.0198C21.7915 9.38324 21.2315 7.81166 20.3217 6.4443C19.4119 5.07694 18.1803 3.956 16.736 3.18079C15.2917 2.40557 13.6793 2 12.0416 2",
    stroke: "url(#paint0_linear_3639_45684)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3639_45684",
    x1: 10.1944,
    y1: 21.5238,
    x2: 8.27405,
    y2: 3.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffff",
    stopOpacity: 0
  })))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "0 0 0",
    to: "360 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1300ms"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLoader);
export default __webpack_public_path__ + "static/media/white-loader.8e854863b5ad923d706f9530d2dfd571.svg";
export { ForwardRef as ReactComponent };